import { render, staticRenderFns } from "./newsModal.vue?vue&type=template&id=10d15022"
import script from "./newsModal.vue?vue&type=script&lang=js"
export * from "./newsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports